// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyC368fZq8_I4p-NJejuxzCm_7h-jSSi9v4",
  authDomain: "dental-sem-crm.firebaseapp.com",
  projectId: "dental-sem-crm",
  storageBucket: "dental-sem-crm.appspot.com",
  messagingSenderId: "474960804467",
  appId: "1:474960804467:web:caa601e755cb3f26960806",
  measurementId: "G-DL8KNVWSSV"
};

const firebaseApp = initializeApp(firebaseConfig);

const messagingPromise = isSupported().then(
  (supported) => (supported ? getMessaging(firebaseApp) : null)
).catch(() => null);

export { messagingPromise, getToken, onMessage };